import { Txt } from "../common/text";
import { Google } from "./google-maps";
import * as $ from "jquery";

export class GoogleMapsModal
{
    private modal: HTMLDivElement;
    private startPlace: any;

    constructor(modal: HTMLDivElement, startPlace: any)
    {
        this.modal = modal;
        this.startPlace = startPlace;
    }

    public showModal(
        onSave: (place: any | null) => void,
        onClear: () => void,
    )
    {
        this.modal.innerHTML = "";

        const modalDialog = document.createElement("div");
        modalDialog.className = "modal-dialog modal-lg";

        const modalContent = document.createElement("div");
        modalContent.className = "modal-content";

        const modalHeader = document.createElement("div");
        modalHeader.className = "modal-header";
        const title = document.createElement("h4");
        title.className = "modal-title";
        title.innerText = Txt.selectLocation;
        modalHeader.appendChild(title);

        const modalBody = document.createElement("div");
        modalBody.className = "modal-body";
        modalBody.style.cssText = "height:450px;position:relative;display:flex;flex-direction:column;gap:8px";

        const autocompleteElement = document.createElement("gmp-place-autocomplete") as any;
        autocompleteElement.id = "autocomplete";
        autocompleteElement.style.borderRadius = "4px";

        const autocompleteContainer = document.createElement("div");
        autocompleteContainer.appendChild(autocompleteElement);

        modalBody.appendChild(autocompleteContainer);

        const mapContainer = document.createElement("div");
        mapContainer.style.cssText = "flex:1;border:1px solid #ccc";
        modalBody.appendChild(mapContainer);

        const modalFooter = document.createElement("div");
        modalFooter.className = "modal-footer";

        const saveBtn = document.createElement("button");
        saveBtn.className = "btn btn-primary";
        saveBtn.textContent = Txt.save;

        const clearBtn = document.createElement("button");
        clearBtn.className = "btn btn-secondary";
        clearBtn.textContent = Txt.clear;

        const closeBtn = document.createElement("button");
        closeBtn.className = "btn btn-default";
        closeBtn.textContent = Txt.close;

        modalFooter.append(saveBtn, clearBtn, closeBtn);

        modalContent.append(modalHeader, modalBody, modalFooter);
        modalDialog.appendChild(modalContent);
        this.modal.appendChild(modalDialog);

        const start = this.startPlace ?? { lat: 58.686057, lng: 25.842476 };
        const map = new Google.maps.Map(mapContainer, { zoom: 7, center: start });
        const marker = new Google.maps.Marker({ position: start, map, draggable: true });

        let tempPlace = this.startPlace ? { ...this.startPlace } : null;

        autocompleteElement.addEventListener("gmp-select", async (event: any) =>
        {
            const prediction = event.placePrediction;
            const place = prediction.toPlace();
            await place.fetchFields({ fields: ["formattedAddress", "location"] });

            const loc = place.location;

            tempPlace = {
                placeId: place.id ?? "",
                formattedAddress: place.formattedAddress ?? "",
                lat: loc.lat(),
                lng: loc.lng()
            };

            marker.setPosition(loc);
            map.setCenter(loc);
            map.setZoom(14);
        });

        map.addListener("click", e =>
        {
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();

            marker.setPosition(e.latLng);

            tempPlace = {
                lat,
                lng,
                formattedAddress: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
                placeId: ""
            };
        });

        saveBtn.onclick = () =>
        {
            onSave(tempPlace ? { ...tempPlace } : null);
            $(this.modal).modal("hide");
        };

        clearBtn.onclick = () =>
        {
            tempPlace = null;
            onClear();
            $(this.modal).modal("hide");
        };

        closeBtn.onclick = () =>
        {
            tempPlace = null;
            $(this.modal).modal("hide");
        };

        $(this.modal).modal({ backdrop: "static", keyboard: true, show: true });
    }
}
